import React, {useEffect} from 'react';
import {Infobox} from '@flixbus/honeycomb-react';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import {useVehicleTypes} from '@/Pages/VehicleTypes/hooks/useVehicleTypes';
import {useCountryCurrency} from '@/Pages/RegionalCosts/hooks/useCountryCurrency';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import ContentLoader from '@/Pages/Common/ContentLoader';
import {fetchCountrySpecificCost} from '@/Pages/RegionalCosts/store/thunks';
import {useCountryCostsQueryParams} from '../../hooks/useCountryCostsQueryParams';
import RegionalCostsVehicleCostContent from './RegionalCostsVehicleCostContent/RegionalCostsVehicleCostContent';

const RegionalCostsVehicleCostTab: React.FC = () => {
  const dispatch = useAppDispatch();

  const {vehicleTypes} = useVehicleTypes();
  const {countryId, year} = useCountryCostsQueryParams();
  const country =
    useAppSelector(({countries}) =>
      countries.list?.find(({id}) => id === countryId)
    ) ?? null;
  const currency = useCountryCurrency(countryId);
  const vehicleCost = useAppSelector(
    ({regionalCosts}) => regionalCosts.vehicleCost
  );
  const vehicleTypeCosts = useAppSelector(
    ({regionalCosts}) => regionalCosts.vehicleTypeCosts?.list
  );

  useEffect(() => {
    dispatch(fetchCountrySpecificCost(countryId, year));
  }, [countryId, year, dispatch]);

  if (countryId === null || year === null) {
    return (
      <Infobox appearance="warning">
        <p>
          Select <strong>country</strong> and <strong>calendar year</strong>
        </p>
      </Infobox>
    );
  }

  if (
    country === null ||
    vehicleCost === null ||
    vehicleTypeCosts === null ||
    vehicleTypes === null
  )
    return <ContentLoader />;

  return (
    <RegionalCostsVehicleCostContent
      country={country}
      year={year}
      vehicleCost={vehicleCost}
      vehicleTypes={vehicleTypes}
      vehicleTypeCosts={vehicleTypeCosts}
      currency={currency}
    />
  );
};

export default React.memo(RegionalCostsVehicleCostTab);
